import { atom } from 'jotai';

export const commandPaletteOpenAtom = atom<boolean>(false);
